<section class="content">

    <div class="form-group">
        <label class="font-weight-bold">{{ 'meals_overwrite' | localise }}</label>

        <div class="row training-row">
            <div class="col-sm-6 col-md-6 training-day">
                {{ 'meal_overwrite' | localise }}
            </div>
            <div class="col-sm-6 col-md-6">
                {{ 'procent_overwrite' | localise }}
            </div>
        </div>

        <div class="row training-row" *ngFor="let meal_overwrite of meal_overwrites; let i = index">
            <div class="col-sm-6 col-md-6 training-day">
                <button class="btn btn-sm btn-danger" (click)="removeTraining(i)"><i class="ti-close"></i></button>
                <button class="btn btn-sm btn-primary" (click)="duplicateTraining(i)"><i class="fa fa-copy"></i></button>

                <select required="required" (change)="onMealChange($event, i)" class="form-control">
                    <option value="">{{ 'meal_overwrite' | localise }}</option>
                    <option
                            *ngFor="let meal of meals_with_daily_meal"
                            [selected]="meal_overwrite.meal && meal_overwrite.meal.id === meal.id"
                            [value]="meal.id">{{ meal.dailyMeal.title + ' - ' + meal.title }}
                    </option>
                </select>
            </div>
            <div class="col-sm-6 col-md-6">
                <input
                        (change)="onPercentageChange($event, i)"
                        [value]="meal_overwrite.percentage"
                        type="number"
                        step="1"
                        min="0"
                        max="100"
                        class="form-control"
                        placeholder="{{ 'procent_overwrite' | localise }}"/>
            </div>

        </div>

        <div class="row">
            <div class="col-sm-12 col-md-3 col-xs-12">
                <button (click)="addTraining()" class="btn btn-sm btn-success add-new-training">
                    <i class="ti-plus"></i>
                    {{ 'add_new_overwrite' | localise }}
                </button>
            </div>
        </div>
    </div>

    <div class="mt-4">
        <button class="btn btn-block btn-primary" (click)="updateProfile()">{{'save' | localise}}</button>
    </div>
</section>
